import type {
  AuditLogFilters,
  AuditLogListOptions,
  AuditLogPage,
  AuditLogRepository,
} from '#/domain/audit/AuditLogRepository'

export class GetAuditLogUseCase {
  constructor(private readonly repository: AuditLogRepository) {}

  async execute(options: AuditLogListOptions, filters?: AuditLogFilters): Promise<AuditLogPage> {
    return this.repository.findAll(options, filters)
  }
}
